"use client";

import { Row, Col, Button } from 'antd/lib';
import CheckedIcon from '../../public/home/checked-icon.svg';
import RoadmapImg from '../../public/roadmap/roadmap-bg.svg';
import ArrowRight from '../../public/home/arrow-right.svg';

import './roadmap.styles.scss';

export default function Roadmap() {

  
  return (
    <div className="roadmap-container">
      <Row className="roadmap-title-wrapper">
        <Col
          xs={{ span: 24 }}
          md={{ span: 24 }}
          sm={{ span: 24 }}
          lg={{ span: 24 }}
          className="ant-col-roadmap-title"  
        >
          <h5 className="roadmap-row-title">
            ROADMAP
          </h5>
          <h1 className="roadmap-row-subtitle">
            Greg Development Plan
          </h1>
        </Col>
      </Row>
      <Row className='roadmap-row-intro'>
        <h3 className='roadmap-row-intro-text'>
          GREG is on a mission to democratize renewable energy production. We will work closely with the best sustainable energy farm manufacturers across Asia (TH) to build renewable energy farms, owned by the Greg community.
        </h3>
      </Row>

      <Row className="roadmap-row">
        <Col
          xs={{ span: 10 }}
          md={{ span: 10 }}
          sm={{ span: 10 }}
          lg={{ span: 10 }}
          className="ant-col-img-roadmap"  
        > 
          <RoadmapImg className="roadmap-side-img" />
        </Col>
        <Col
          xs={{ span: 14 }}
          md={{ span: 14 }}
          sm={{ span: 14 }}
          lg={{ span: 14 }}
          className="ant-col-title-roadmap"  
        >
          <Row>
            <div className='roadmap-list-container'>
              <div className='roadmap-list-item-wrapper'>
                <Col
                  xs={{ span: 3 }}
                  md={{ span: 3 }}
                  sm={{ span: 3 }}
                  lg={{ span: 3 }}
                  className="ant-col-list-roadmap-icon"  
                >
                  <div className='list-roadmap-icon'>
                    <CheckedIcon className='list-checked-icon' />
                  </div>
                </Col>
                <Col
                  xs={{ span: 21 }}
                  md={{ span: 21 }}
                  sm={{ span: 21 }}
                  lg={{ span: 21 }}
                  className="ant-col-list-roadmap-text"  
                >
                  <h2>
                    Greg Certificate Sale & Ownership Integration
                  </h2>
                  <h5>
                    TO BE ANNOUNCED marks the day when you can become a part of the Greg Community. By purchasing Greg Certificates, you claim ownership in solar or hydro farms and join a community dedicated to driving positive change. Ownership is secured transparently through blockchain, making participation in green energy simple and impactful.
                  </h5>
                </Col>
              </div>
              
              <div className='roadmap-list-item-wrapper'>
                <Col
                  xs={{ span: 3 }}
                  md={{ span: 3 }}
                  sm={{ span: 3 }}
                  lg={{ span: 3 }}
                  className="ant-col-list-roadmap-icon"  
                >
                  <div className='list-roadmap-icon'>
                    <CheckedIcon className='list-checked-icon' />
                  </div>
                </Col>
                <Col
                  xs={{ span: 21 }}
                  md={{ span: 21 }}
                  sm={{ span: 21 }}
                  lg={{ span: 21 }}
                  className="ant-col-list-roadmap-text"  
                >
                  <h2>
                    Community-Driven Land Selection
                  </h2>
                  <h5>
                    Once the Greg Certificate sales reach their goal, we will collectively move forward with acquiring land for our renewable farms. Our team, with input from the Greg Community, is scouting locations that maximize energy production while supporting local ecosystems and community benefits.
                  </h5>
                </Col>
              </div>

              <div className='roadmap-list-item-wrapper'>
                <Col
                  xs={{ span: 3 }}
                  md={{ span: 3 }}
                  sm={{ span: 3 }}
                  lg={{ span: 3 }}
                  className="ant-col-list-roadmap-icon"  
                >
                  <div className='list-roadmap-icon'>
                    <CheckedIcon className='list-checked-icon' />
                  </div>
                </Col>
                <Col
                  xs={{ span: 21 }}
                  md={{ span: 21 }}
                  sm={{ span: 21 }}
                  lg={{ span: 21 }}
                  className="ant-col-list-roadmap-text"  
                >
                  <h2>
                    Building and Bringing Greg Farms to Life
                  </h2>
                  <h5>
                    The heart of our journey begins with constructing our solar and hydro power farms. Partnering with experienced engineering teams, we ensure that each installation meets the highest standards of sustainability and efficiency. With every panel and turbine installed, the Greg Community vision of change becomes a reality.
                  </h5>
                </Col>
              </div>

              <div className='roadmap-list-item-wrapper'>
                <Col
                  xs={{ span: 3 }}
                  md={{ span: 3 }}
                  sm={{ span: 3 }}
                  lg={{ span: 3 }}
                  className="ant-col-list-roadmap-icon"  
                >
                  <div className='list-roadmap-icon'>
                    <CheckedIcon className='list-checked-icon' />
                  </div>
                </Col>
                <Col
                  xs={{ span: 21 }}
                  md={{ span: 21 }}
                  sm={{ span: 21 }}
                  lg={{ span: 21 }}
                  className="ant-col-list-roadmap-text"  
                >
                  <h2>
                    Community Compliance & Ownership Assurance 
                  </h2>
                  <h5>
                    As construction progresses, we will initiate thorough Know Your Customer (KYC) procedures to maintain compliance and transparency. This step ensures that all Greg Certificate holders are recognized as rightful stakeholders, solidifying their ownership and participation in the shared journey.
                  </h5>
                </Col>
              </div>

              
              <div className='roadmap-list-item-wrapper'>
                <Col
                  xs={{ span: 3 }}
                  md={{ span: 3 }}
                  sm={{ span: 3 }}
                  lg={{ span: 3 }}
                  className="ant-col-list-roadmap-icon"  
                >
                  <div className='list-roadmap-icon'>
                    <CheckedIcon className='list-checked-icon' />
                  </div>
                </Col>
                <Col
                  xs={{ span: 21 }}
                  md={{ span: 21 }}
                  sm={{ span: 21 }}
                  lg={{ span: 21 }}
                  className="ant-col-list-roadmap-text"  
                >
                  <h2>
                    Expanding the Greg Vision
                  </h2>
                  <h5>
                    Our sights are set beyond a single project. The Greg Community is a movement that will expand to encompass more renewable farms and innovative energy solutions. We are developing a decentralized platform to simplify and scale investments in green projects, inviting more people to become part of the Greg mission and support community-powered sustainability.
                  </h5>
                </Col>
              </div>

              <div className='roadmap-list-item-wrapper'>
                <Col
                  xs={{ span: 3 }}
                  md={{ span: 3 }}
                  sm={{ span: 3 }}
                  lg={{ span: 3 }}
                  className="ant-col-list-roadmap-icon"  
                >
                  <div className='list-roadmap-icon'>
                    <CheckedIcon className='list-checked-icon' />
                  </div>
                </Col>
                <Col
                  xs={{ span: 21 }}
                  md={{ span: 21 }}
                  sm={{ span: 21 }}
                  lg={{ span: 21 }}
                  className="ant-col-list-roadmap-text"  
                >
                  <h2>
                    Celebrating Impact and Sharing Returns 
                  </h2>
                  <h5>
                    Once our farms are operational and generating revenue, it is time for the Greg Community to share in the fruits of our collective efforts. Profits will be distributed as dividends to Greg Certificate holders, creating a cycle of continuous support and reward that reinforces our commitment to sustainable energy and shared growth.
                  </h5>
                </Col>
              </div>

            </div>
          </Row>
        </Col>
        <Row>
          <h3 className="roadmap-row-footer">
            We are not just building renewable farms — we are creating a movement where everyone can proudly identify as a Good Renewable Energy Guy.
          </h3>

          <Button className='roadmap-row-footer-btn' icon={<ArrowRight />} iconPosition="end">
            Join Greg Community
          </Button>
        </Row>
      </Row>
    </div>
  );
}